/**
 * view model for the main view
 */
define('viewmodels/app/index',[
        'plugins/router','atn/atn', 'jquery', 'atn/jquerySetup', 'dataSource/shell/shellRegistry',
        'postLogin/index', 'dataSource/uiVersion', 'dataSource/timeData', './__subrouter', './__loginAndNavigationPanel'
    ],
    function(
        rootRouter, atn, $, jquerySetup, shellRegistry, postLogin, uiVersion, timeData, router, loginNavigationPanel
    ) {
        'use strict';

        return {
            router: router,
            activate: activate,
            isLoading: shellRegistry.isLoading,
            noConnection: jquerySetup.noConnection,
            toasterMessages: atn.toasterRegistry.toasterRegistryList,
            showToaster: atn.toasterRegistry.showToasterMessages,
            sessionRetrying: postLogin.retrying,
            sessionRetryPopup: postLogin.retryPopup,
            reBrandingResources : atn.config.oemResourcesMap,
            reBrandingFolder: atn.config.oemRebrandingFolder,
            uiVersion:uiVersion.uiVersion,
            toggleSidePanel:loginNavigationPanel.toggleSidePanel
        };

        /**
         * callback to be called when activation is called
         * @return {jquery.promise} promise to track weather this viewModel
         * is loadable
         */
        function activate() {
            var deferred = $.Deferred();
            var locationHref = atn.utils.parseURL(window.location.href);
            var promise = timeData.getTimezoneList();

            promise.done(function() {
                if(locationHref.path === 'app') {
                    rootRouter.navigate('#app/analytics');
                }
                deferred.resolve();
            });
            promise.fail(function(xhr) {
                if(xhr.status !== 403){
                    _.defer(rootRouter.navigate, '#site/failure/dataFetch');
                }
                deferred.reject();
            });

            return deferred.promise();
        }

    });

